document.addEventListener('DOMContentLoaded', () =>{
    document.querySelectorAll('.one-click-button').forEach(button => {
        button.addEventListener('click', () => {
            button.disabled = true;
        });
    });
});
